import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-logo';
export var ID = 'icon-logo';
/* eslint-disable max-len */

export var SVGLogo = function SVGLogo() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 23 32"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M22.8564813,20.4147795 C22.8564813,26.5320372 17.845423,31.4901241 11.6595143,31.4901241 C5.47864249,31.4919928 0.463806583,26.5326601 0.463806583,20.4147795 C0.463806583,14.2981446 5.47864249,9.33943479 11.6588847,9.33943479 C17.845423,9.33943479 22.8564813,14.2981446 22.8564813,20.4147795",
    fill: "#FF893E"
  }), React.createElement("path", {
    d: "M13.1523173,2.12903099 C11.9887998,1.94839717 11.0443863,1.95213442 10.2347091,1.83877113 C9.23300112,1.76215747 7.33850756,1.50179562 6.7907477,0.619181406 C6.7907477,0.619181406 6.77815552,0.697663686 6.769341,0.842793618 C6.74793429,1.16731162 6.74604546,1.8169705 6.93933544,2.65349194 C7.12318127,3.36045534 7.38887628,4.08299062 7.76601209,4.76877626 C7.88689702,4.98553685 8.0247814,5.20478893 8.17651717,5.42715539 C9.11148658,6.76945154 10.5948455,7.72743366 12.8249206,8.22511098 C15.748825,8.87601561 18.5235119,9.34441779 20.6767748,12.0570395 C20.6818117,12.0464506 20.6843301,12.0327473 20.6899966,12.0209127 C21.0860207,10.5496814 19.5856624,3.12064838 13.1523173,2.12903099",
    fill: "#78A22F"
  }))));
};
/* eslint-disable max-len */
// width="23px" height="32px"

var Logo = function Logo(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGLogo
  });
};

Logo.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Logo;